import React from "react";
import PropTypes from "prop-types";

import { Graphics } from "./components/Graphics";

import "./style.scss";

export class Box extends React.Component {
  constructor(props){
    super(props)

    const interactions = (heldObj, target) => {
      //Don't run if this box not the held object
      if(heldObj.type !== "Box" || heldObj.id !== this.props.id){
        return null;
      }
      if (target === undefined || target === null) {
        return null;
      }
      //All GlassTube interactions
      if (target.type === "GlassTube") {
        //Get the targeted GlassTube
        const tubeID = target.id

        const targetGlassTube = this.props.interactionProps.glassTubes[tubeID - 1]

        if(targetGlassTube.boxId !== -1) {
          //this.makeToast("WARNING", "This cuvette already contains a lid.", "Cuvette contains lid!");
          return null;
        }

        this.props.onDropBox({
          boxId: this.props.id,
          tubeID: targetGlassTube.id,
          type: "box"
        })

        this.props.setBoxesInScene({
          id: this.props.id,
          inScene: false
        });

        // Reset the tube position to a zero transform
        heldObj.htmlObj.style.transform = "translate3d(0px,0px,0px) rotateZ(0deg)"

        // if(targetGlassTube.open) {
        //   targetGlassTube.onDropItem(this.props.id);

        // } else {
        //   this.makeToast("WARNING", "You must open the glass tube first.", "Glass Tube is closed!")
        // }
      } else {
        return null
      }
    }
    Object.defineProperty(interactions, 'name', {value: ('box_interactions_'+this.props.id), configurable: true});
    this.props.pushInteractions([interactions])
  }



  componentWillMount() {
    this.props.createBox({
      props: this.props.defaultProps,
    });
  }
  boxSelected = (e) => {

    this.props.setBoxHeld({
      id: this.props.id,
      held: true,
    })
    this.props.setHeldObject({
      id: this.props.id,
      type: "Box",
      htmlObj: e.target,
    });
    if(!this.props.controlsVisible){
      this.showControls()
  }
  }

  boxUnselected = (e) => {
    this.props.setBoxHeld({
      id: this.props.id,
      held: false,
    })
  }

  showControls = ()=> {
    this.props.hideAllControls();
    this.props.setBoxControlVisibility({id: this.props.id, controlsVisible: true});
  }
  render() {
    return (
      <ul style={{
        visibility: !this.props.inScene ? "hidden" : null,
        zIndex: this.props.controlsVisible ? 99 : null,
      }}>
        <li
          id={"Box_"+this.props.id}
          className={'Box draggable'}
          onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.boxSelected() } }
          onDragStart={(e) => this.boxSelected(e)}
          onDragEnd={(e) => this.boxUnselected(e)}
          draggable
          tabIndex={0}
          style={{ transform: "translate3d(0px, 0px, 0px) rotateZ(0deg)" }}>

          <Graphics id={this.props.id} />
        </li>
      </ul>
    );
  }
}

Box.propTypes = {
  createBox: PropTypes.func,
};

Box.defaultProps = {};
